import React, { Component }  from 'react';
import {Button} from "@mui/material";
import "./ButtonsStyleSheet.css"
import PropTypes from "prop-types";

const ButtonPrimaryRaiko = ({className, onClick, label,onKeyDown}) => {
    return (
        <Button
            id="PrimaryButton"
            className={className}
            onClick={onClick}
            onKeyDown={onKeyDown}
        >
            <span>{label}</span>
        </Button>
    )
}

export default ButtonPrimaryRaiko;

ButtonPrimaryRaiko.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className:PropTypes.string
}